import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { api } from '../api/client'

/** Öffentlicher KV (ohne Login). Kein Retry: ein ungültiger/abgelaufener Token soll sofort die Fehlermeldung
 *  zeigen, nicht mehrfach nachladen. */
export function usePublicEstimate(token: string) {
  return useQuery({
    queryKey: ['publicEstimate', token],
    queryFn: () => api.getPublicEstimate(token),
    enabled: token.length > 0,
    retry: false,
  })
}

/** Kundenentscheid (freigeben/ablehnen). Bei Erfolg den KV neu laden, damit der Status (approved/declined) zieht. */
export function useDecideEstimate(token: string) {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: (decision: 'approve' | 'decline') =>
      decision === 'approve' ? api.approveEstimate(token) : api.declineEstimate(token),
    onSuccess: () => void qc.invalidateQueries({ queryKey: ['publicEstimate', token] }),
  })
}
